
import React from 'react'

export default function ScheduleComponent({ quoteData, handleChange }: any) {

    return (


        <div className="w-full font-bold space-y-4">

            <div className=" w-1/2">
                <label className="block text-xs font-bold mb-1" htmlFor="date">
                    Schedule Date <span className="text-red-500">*</span>
                </label>

                <input
                    required
                    id="datetime"
                    type="datetime-local"
                    name="scheduleDate"
                    min={
                        new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000)
                            .toISOString()
                            .slice(0, 16)
                    }
                    onClick={(event) => {
                        const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                        input.showPicker(); // Now you can call showPicker() safely
                    }}
                    className={"w-full py-2 px-3 border border-black/50 text-xs rounded bg-gray-50" }
                    onChange={(e) => handleChange(e.target.value, 'date')}
                    value={quoteData?.date}
                />
            </div>



        </div>



    )
}